export const regFlow = "REGISTRATION_FLOW";
export const sprFlow = "SPR_FLOW";
export const sprWithJobIdFlow = "SPR_WITH_JOBID_FLOW";

export const organicMarketingChannels = [
  "google",
  "bing",
  "adzuna",
  "yahoo",
  "jobtome",
  "duckduckgo",
  "baidu",
  "ask.com",
  "sogou",
  "yandex",
  "babylon",
  "so.com",
  "privatejobshub",
  "search.smt.docomo",
  "msn",
  "Lycos",
];

export const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const months = [
  { id: 1, text: "January", value: "01" },
  { id: 2, text: "February", value: "02" },
  { id: 3, text: "March", value: "03" },
  { id: 4, text: "April", value: "04" },
  { id: 5, text: "May", value: "05" },
  { id: 6, text: "June", value: "06" },
  { id: 7, text: "July", value: "07" },
  { id: 8, text: "August", value: "08" },
  { id: 9, text: "September", value: "09" },
  { id: 10, text: "October", value: "10" },
  { id: 11, text: "November", value: "11" },
  { id: 12, text: "December", value: "12" },
];

export const yearlySalaryMode = "7cad9bf9-222e-11e9-9330-1418775c7275";
export const monthlySalaryMode = "69a8f26e-222e-11e9-9330-1418775c7275";
